import React from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import './InvestorTwinsSection.css';

function InvestorTwinsSection({ cardData, startSession, packagesRef }) {
  return (
    <section className="investor-twins-section" ref={packagesRef}>
      <Container>
        <h2 className="section-title text-center mb-5">Pitch to the Digital Twins of Silicon Valley's Finest</h2>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
          {cardData.map((card, index) => (
            <div key={index} className="col">
              <Card className="investor-card shadow-sm">
                <Card.Img variant="top" src={card.image} />
                <Card.Body>
                  <Card.Title className="card-title">{card.title}</Card.Title>
                  <Card.Text className="card-text">{card.overview}</Card.Text>
                  <div className="d-flex justify-content-between align-items-center">
                    <Button 
                      variant="dark" 
                      className="investor-button"
                      onClick={() => startSession(card.packageAssistantId, card.voiceName)}
                    >
                      {card.cta_label}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default InvestorTwinsSection;
